import type { CourseAssetListResponsePageableSort } from './courseAssetListResponsePageableSort';

/**
 * Spring Data Pageable 정보
 */
export type CourseAssetListResponsePageable = {
  /** 요청된 페이지 번호 */
  page?: number;
  /** 요청된 페이지 크기 */
  size?: number;
  /** Spring Data Sort 정보 */
  sort?: CourseAssetListResponsePageableSort;
};
